module.exports = __webpack_public_path__ + "img/Ukraine.8ea392c7.svg";